<template>
  <Content title="我们的服务" class="bg-white">
    <div id="gpServiceCarousel" class="carousel slide" data-ride="carousel" data-interval="false">
      <ol class="carousel-indicators">
        <li
          v-for="(service, i) in services"
          :key="i"
          data-target="#gpServiceCarousel"
          :data-slide-to="i"
          class="indicator-item"
          :class="{ active: i === 0 }"
        ></li>
      </ol>
      <div class="carousel-inner th-pb-30">
        <div
          v-for="(service, i) in services"
          :key="i"
          class="carousel-item text-center"
          :class="{ active: i === 0 }"
        >
          <div class="d-flex flex-column align-items-center th-px-42">
            <div class="service-icon-wrapper d-flex flex-column align-items-center">
              <img width="20" :src="service.image" alt="#" />
            </div>
            <div class="th-fs-14 th-mt-24">{{ service.title }}</div>
            <div class="th-fs-14 th-mt-24">
              {{ service.desc }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </Content>
</template>
<script>
import Content from '@/shared/components/content.vue'
import { services } from './data'
export default {
  name: 'MobileService',
  components: { Content },
  setup() {
    return { services }
  },
}
</script>

<style lang="scss" scoped>
.service-icon-wrapper {
  width: 82px;
  height: 82px;
  background: #ffffff;
  border: 3px solid #cddbff;
  border-radius: 50%;

  img {
    width: 44px;
    height: 44px;
    margin: auto;
    object-fit: contain;
  }
}

// 覆盖bootstrap的预设样式
.indicator-item {
  box-sizing: content-box;
  width: 5px;
  height: 5px;
  background: #e6e6e6;
  border-radius: 50%;
  border: 0;
  opacity: 1;
}

.indicator-item.active {
  background: #4b7ef6;
}
</style>
